import { AvitoFormatOptionsDto } from "definitions/exporter";

import { ExportTaskFormValues } from "./ExportTasksForm.types";

// Бэк-дефолт overflow-policy для title и description — литерал "skip".
// Используем единый литерал-константу: titleOverflowPolicy и
// descriptionOverflowPolicy имеют разные сгенерированные enum-ы, но
// семантически дефолт один и тот же, и привязываться к одному из enum'ов
// (как было раньше, к Title) — скрытое допущение, что они никогда не разойдутся.
const OVERFLOW_POLICY_SKIP = "skip" as const;

// UI работает в auto-режиме Avito (см. AvitoFormatOptionsGuard в export-api):
// клиент шлёт только общие теги фида, а шаблон/состояние/goodsType/apparelType
// бэк подставляет сам по категории товара. Срезаем всю classification —
// чтобы payload остался auto и dirty-check не врал, в т.ч. при загрузке
// старых single/multi-задач (они мигрируют в auto при сохранении).
const stripAvitoClassification = (
  options: AvitoFormatOptionsDto,
): AvitoFormatOptionsDto => {
  const next: AvitoFormatOptionsDto = { ...options };
  delete next.templateId;
  delete next.goodsType;
  delete next.apparelType;
  delete next.condition;
  delete next.templateGroups;
  return next;
};

// Нормализует avitoOptions перед отправкой и dirty-сравнением: срезает дефолтные
// overflow-политики (payload остаётся минимальным, сохранённые задачи без новых
// полей продолжают работать) и всю classification (auto-режим — бэк решает сам).
export const normalizeAvitoFormValues = (
  values: ExportTaskFormValues,
): ExportTaskFormValues => {
  if (!values.avitoOptions) return values;
  const { titleOverflowPolicy, descriptionOverflowPolicy, ...rest } =
    values.avitoOptions;
  const next: AvitoFormatOptionsDto = { ...rest };
  if (titleOverflowPolicy && titleOverflowPolicy !== OVERFLOW_POLICY_SKIP) {
    next.titleOverflowPolicy = titleOverflowPolicy;
  }
  if (
    descriptionOverflowPolicy &&
    descriptionOverflowPolicy !== OVERFLOW_POLICY_SKIP
  ) {
    next.descriptionOverflowPolicy = descriptionOverflowPolicy;
  }
  return { ...values, avitoOptions: stripAvitoClassification(next) };
};
